import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import SEO from "../../layout/SEO";
import ArticlesGrid from "../../layout/ArticlesGrid";
import { withRouter } from "react-router-dom";

class StageArticles extends Component {
  componentDidMount() {
    window.resetScript();
  }

  render() {
    return (
      <>
        <SEO
          title="Stages"
          description="Découvrez mes expériences de stage et les projets réalisés durant mes différentes missions."
          keywords="stages, expériences professionnelles, projets, missions"
        />
        <Header active="Stage" modeDark={true} />
        <BannerSimple 
          title="Stage" 
          boxElement={[
            { name: "Accueil", link: "/" },
            { name: "Stage", link: window.location.pathname }
          ]} 
        />
        
        <section className="portfolio_details_area section-gap">
          <div className="container">
            <ArticlesGrid 
              type="STAGE"
              itemsPerPage={12}
              emptyMessage="Aucun article de stage trouvé"
            />
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default withRouter(StageArticles);

